/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2022-11-14 11:27:50
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-09-21 09:57:01
 */
import config from './config/exam'
import axios from '@/utils/request'
export const examPlanList = params => axios.post(config.examPlanList, params) // 考试计划列表
export const examPlanRemove = params => axios.post(config.examPlanRemove, params)
export const examPlanUpdate = params => axios.post(config.examPlanUpdate, params)
export const examPlanPublish = params => axios.post(config.examPlanPublish, params)
export const examPlanUnPublish = params => axios.post(config.examPlanUnPublish, params)
export const examPlanStop = params => axios.post(config.examPlanStop, params)
export const examPlanExport = params =>
  axios.post(config.examPlanExport, params, { responseType: 'blob' })
export const examPlanGetById = params => axios.post(config.examPlanGetById, params)
export const filterJobLevel = params => axios.post(config.filterJobLevel, params)
export const filterWorkType = params => axios.post(config.filterWorkType, params)
export const addExamPlan = params => axios.post(config.addExamPlan, params)
export const examPaperList = params => axios.post(config.examPaperList, params)
export const examPaperExport = params =>
  axios.post(config.examPaperExport, params, { responseType: 'blob' })
export const examPaperRemove = params => axios.post(config.examPaperRemove, params)
export const examPaperCreate = params => axios.post(config.examPaperCreate, params)
export const examPaperEdit = params => axios.post(config.examPaperEdit, params)
export const examPaperStatusEdit = params => axios.post(config.examPaperStatusEdit, params)
export const examPaperDetail = params => axios.post(config.examPaperDetail, params)
export const examPaperTempDownload = params =>
  axios.post(config.examPaperTempDownload, params, {
    responseType: 'blob',
  })
export const examPaperQuestionImport = params => axios.post(config.examPaperQuestionImport, params)
export const examPaperRelatedPlan = params => axios.post(config.examPaperRelatedPlan, params)
export const examSubjectCreate = params => axios.post(config.examSubjectCreate, params)
export const examSubjectGetList = params => axios.post(config.examSubjectGetList, params)
export const examSubjectBindPaper = params => axios.post(config.examSubjectBindPaper, params)
export const examSubjectDel = params => axios.post(config.examSubjectDel, params)
export const examUserTempDownload = params =>
  axios.post(config.examUserTempDownload, params, {
    responseType: 'blob',
  })
export const examUserImport = params => axios.post(config.examUserImport, params)
export const examUserList = params => axios.post(config.examUserList, params)
export const examUserDel = params => axios.post(config.examUserDel, params)
export const examUserExport = params =>
  axios.post(config.examUserExport, params, {
    responseType: 'blob',
  })
export const filterAdminList = params => axios.post(config.filterAdminList, params)
export const teacherList = params => axios.post(config.teacherList, params)
export const userTeacherList = params => axios.post(config.userTeacherList, params)
export const userTeacherDelete = params => axios.post(config.userTeacherDelete, params)
export const userTeacherAdd = params => axios.post(config.userTeacherAdd, params)
export const paperQuestionList = params => axios.post(config.paperQuestionList, params)
export const paperQuestionSort = params => axios.post(config.paperQuestionSort, params)
export const paperQuestionDetail = params => axios.post(config.paperQuestionDetail, params)
export const paperQuestionCreate = params => axios.post(config.paperQuestionCreate, params)
export const paperQuestionEdit = params => axios.post(config.paperQuestionEdit, params)
export const paperQuestionRemove = params => axios.post(config.paperQuestionRemove, params)
export const paperQuestionImport = params => axios.post(config.paperQuestionImport, params)
export const examresultPlanDropDown = params => axios.post(config.examresultPlanDropDown, params)
export const examresultSubjectDropDown = params =>
  axios.post(config.examresultSubjectDropDown, params)
export const examRecordPage = params => axios.post(config.examRecordPage, params)
export const examRecordExport = params =>
  axios.post(config.examRecordExport, params, {
    responseType: 'blob',
  })
export const examMarkPage = params => axios.post(config.examMarkPage, params)
export const examMarkExport = params =>
  axios.post(config.examMarkExport, params, {
    responseType: 'blob',
  })
export const examRecordInfo = params => axios.post(config.examRecordInfo, params)
export const examMarkUserList = params => axios.post(config.examMarkUserList, params)
export const examMarkCheckDetail = params => axios.post(config.examMarkCheckDetail, params)
export const submitMarkscore = params => axios.post(config.submitMarkscore, params)
export const changeQuestionName = params => axios.post(config.changeQuestionName, params)
export const changeQuestionAnwser = params => axios.post(config.changeQuestionAnwser, params)
export const changeQuestionScore = params => axios.post(config.changeQuestionScore, params)

export const testPaperData = params => axios.post(config.testPaperData, params)
export const examPlanPublishRemove = params => axios.post(config.examPlanPublishRemove, params)
export const examPlanSubjectDetail = params => axios.post(config.examPlanSubjectDetail, params)
export const examPlanSubJectEdit = params => axios.post(config.examPlanSubJectEdit, params)

export const examCheckCommentSubmit = params => axios.post(config.examCheckCommentSubmit, params)
export const examPhotoAddRecord = params => axios.post(config.examPhotoAddRecord, params)

// 查询科目阅卷人（含已分配状态和题目分配）
export const subjectMarkingTeachers = params => axios.post(config.subjectMarkingTeachers, params)
// 提交科目阅卷人分配（含阅卷模式和题目分配）
export const subjectMarkingBind = params => axios.post(config.subjectMarkingBind, params)
// 编辑科目阅卷人分配（分题段阅卷仅待阅卷状态可编辑）
export const subjectMarkingEdit = params => axios.post(config.subjectMarkingEdit, params)
// 查询科目下需要阅卷的题目列表
export const subjectMarkingQuestions = params => axios.post(config.subjectMarkingQuestions, params)

// 按科目查询阅卷视频列表
export const markingVideoList = params => axios.post(config.markingVideoList, params)
// 分页查询阅卷视频列表
export const markingVideoPage = params => axios.post(config.markingVideoPage, params)
// 添加阅卷视频
export const markingVideoAdd = params => axios.post(config.markingVideoAdd, params)
// 编辑阅卷视频文件信息
export const markingVideoEdit = params => axios.post(config.markingVideoEdit, params)
// 查询阅卷视频详情（id 为 query 参数）
export const markingVideoDetail = id => axios.post(`${config.markingVideoDetail}?id=${id}`)

// 题库查询--分页（新）
export const questionStorePage = params => axios.post(config.questionStorePage, params)
// 题库创建
export const questionStoreCreate = params => axios.post(config.questionStoreCreate, params)
// 题库重命名
export const questionStoreRename = params => axios.post(config.questionStoreRename, params)
// 题库导入--excel
export const questionStoreImport = params => axios.post(config.questionStoreImport, params)
// 题库excel模板下载
export const questionStoreTempDownload = params =>
  axios.post(config.questionStoreTempDownload, params, {
    responseType: 'blob',
  })
// 题库详情--分页
export const questionStoreDetailPage = params => axios.post(config.questionStoreDetailPage, params)
// 题库删除题目
export const questionStoreDeleteQuestion = params =>
  axios.post(config.questionStoreDeleteQuestion, params)
// 题库导入试题到试卷
export const paperImportFromStore = params => axios.post(config.paperImportFromStore, params)
// 获取试卷抽题配置
export const paperGetQuestionConfig = params => axios.post(config.paperGetQuestionConfig, params)
// 编辑试卷抽题配置
export const paperEditQuestionConfig = params => axios.post(config.paperEditQuestionConfig, params)

export const examRusltExport = params =>
  axios.post(config.examRusltExport, params, {
    responseType: 'blob',
  })

export const questionStoreList = params => axios.post(config.questionStoreList, params)
export const questionListSort = params => axios.post(config.questionListSort, params)
export const questionDetail = params => axios.post(config.questionDetail, params)
export const questionCreate = params => axios.post(config.questionCreate, params)
export const questionEdit = params => axios.post(config.questionEdit, params)
export const questionRemove = params => axios.post(config.questionRemove, params)
export const questionStoreDelete = params => axios.post(config.questionStoreDelete, params)
export const storeQuestionExport = params =>
  axios.post(config.storeQuestionExport, params, {
    responseType: 'blob',
  })
